// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Video_wrapper__1xLJi","frame":"Video_frame__3e7Nd","error":"Video_error__3WG2e"};